import React from "react";
import * as PropTypes from "prop-types";
import {animated} from "react-spring";

export class About extends React.Component {
    render() {
        return <section id="about"
                        style={
                            {backgroundImage: `url(${this.props.imageSrc})`}
                        }
        >
            <animated.div style={this.props.style} className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <h2>{this.props.title}</h2>
                        <p>{this.props.content}</p>
                    </div>
                    <div className="col-lg-3">
                        <h3>Where</h3>
                        <p>{this.props.where}</p>
                    </div>
                    <div className="col-lg-3">
                        <h3>When</h3>
                        <p>{this.props.days}<br/>{this.props.when}</p>
                    </div>
                </div>
            </animated.div>
        </section>;
    }
}

About.propTypes = {
    style: PropTypes.any,
    title: PropTypes.any,
    content: PropTypes.any,
    where: PropTypes.any,
    days: PropTypes.any,
    when: PropTypes.any,
    imageSrc: PropTypes.string
};
